<template>
    <div class="">
        <drawer 
            :title="addEditTitle" 
            :dialogShow="addEditShow" 
            @handleChange="handleChangeDrawer"
        >
            <div slot="body">
                <div class="pay-mains">
                    <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
                        <el-form-item ref="customerName" label="客户姓名：" prop="customerName" :rules="$rules.required">
                            <el-input v-model="form.customerName"></el-input>
                        </el-form-item>
                        <el-form-item ref="mobile" label="电话号码：" prop="mobile" :rules="$rules.phone">
                            <el-input v-model="form.mobile"></el-input>
                        </el-form-item>
                        <el-form-item ref="customerNo" label="客户编号：" prop="customerNo" :rules="$rules.required">
                            <el-input v-model="form.customerNo"></el-input>
                        </el-form-item>
                        <el-form-item ref="cardOldId" label="套餐类型：" prop="cardOldId" :rules="$rules.required">
                            <el-select v-model="form.cardOldId">
                                <el-option v-for="(item,index) in columns" :key="index" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item ref="originNum" label="套餐次数：" prop="originNum" :rules="$rules.zeroNum">
                            <el-input v-model="form.originNum"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                 <div class="drawer-footer">
                    <div class="btns">
                        <el-button type="danger" class="large-btn" @click="onSubmit">保存</el-button>
                    </div>
                </div>
            </div>
        </drawer>
    </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
export default {
    mixins: [minxin],
    components:{drawer},
    data () {
        return {
            addEditTitle: '',
            addEditShow: false,
            form: {
                mobile: ''
            },
            columns: [],
            cardOldName: '',
            showPicker: false,
        }
    },
    created(){
        this.editInit();
    },
    methods: {
        editInit(){
            this.$on('set',function(org){
                Object.assign(this.$data,this.$options.data());
                // this.$refs['form'].clearValidate();
                if(org){
                    this.addEditTitle = '纸质套餐编辑';
                    this.$api.get(this.$url.cardOld.get,{
                        id: org.id
                    }).then( res => {
                        if(res){
                            this.form = res;                           
                            this.form.text = this.form.cardOldIdCn;
                            this.cardOldName = this.form.cardOldIdCn;
                            this.cardOldList();
                        }
                    }).catch(error => {
        
                    })
                } else {
                    this.addEditTitle = '纸质套餐新增';
                    this.cardOldList();
                }
                this.addEditShow = true;
            })
            
        },
        handleChangeDrawer(){
            this.$refs['form'].clearValidate();
            this.addEditShow = false;
            this.$emit('change',false);
        },
        cardOldList(){
            this.$api.post(this.$url.cardOld.list)
            .then( res => {
                this.columns = res;
                this.columns.forEach((item) => {
                    item.text = item.name;
                })
            }).catch(error => {

            })
        },
        onSubmit(values){
            this.$refs.form.validate((valid,object) => {
                if (valid) {
                    this.$api.post(this.$url.cardOld.save,this.form)
                    .then( res => {
                        if(res){
                            this.addEditShow = false;
                            this.$refs['form'].clearValidate();
                            this.$emit('change',true);
                        }
                    }).catch(error => {

                    })
                }
            });
        },
    }
}
</script>
<style scoped lang="less">
/deep/ .el-input--small .el-input__inner{
    width: 200px;
    height: 40px;
    line-height: 40px;
}
/deep/ .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label{
    line-height: 40px;
}
.pay-mains{
    padding: 30px;
}
</style>